import { useContext } from "react";
import { FilterContext } from "utils/providers";

export const useFilter = () => {
  return useContext(FilterContext);
};
